import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "control-sidebar control-sidebar-dark",
  style: {"padding":"16px","padding-top":"73px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Customize AdminLTE", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1)
const _hoisted_4 = { style: {"padding":"8px 0"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Dark mode ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Light Navbar Variants ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Dark Navbar Variants ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Accent Color Variants ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Light Sidebar Variants ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Dark Sidebar Variants ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Brand Logo Variants ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_checkbox = _resolveComponent("app-checkbox")!
  const _component_app_select = _resolveComponent("app-select")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_app_checkbox, { onChange: _ctx.handleDarkModeChange }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onChange"]),
      _createVNode(_component_app_select, {
        modelValue: _ctx.navbarVariant,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.navbarVariant) = $event)),
        class: "mt-3",
        options: _ctx.navbarLightVariants,
        type: "custom",
        onChange: _ctx.onNavbarVariantChange
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["modelValue", "options", "onChange"]),
      _createVNode(_component_app_select, {
        modelValue: _ctx.navbarVariant,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.navbarVariant) = $event)),
        class: "mt-3",
        options: _ctx.navbarDarkVariants,
        type: "custom",
        onChange: _ctx.onNavbarVariantChange
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["modelValue", "options", "onChange"]),
      _createVNode(_component_app_select, {
        class: "mt-3",
        options: [],
        type: "custom",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_app_select, {
        class: "mt-3",
        modelValue: _ctx.sidebarSkin,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sidebarSkin) = $event)),
        options: _ctx.lightSidebarSkins,
        type: "custom",
        onChange: _ctx.onSidebarSkinChange
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["modelValue", "options", "onChange"]),
      _createVNode(_component_app_select, {
        class: "mt-3",
        modelValue: _ctx.sidebarSkin,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sidebarSkin) = $event)),
        options: _ctx.darkSidebarSkins,
        type: "custom",
        onChange: _ctx.onSidebarSkinChange
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["modelValue", "options", "onChange"]),
      _createVNode(_component_app_select, {
        class: "mt-3",
        options: [],
        type: "custom",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ])
  ]))
}